const isEmptyOrUndefined = (value: string | undefined): boolean => {
  return !value || value.trim() === "";
};

const escapeRegex = (str: string): string => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

export const validateEmail = (
  email: string | undefined,
  password: string,
): boolean => {
  if (isEmptyOrUndefined(email)) {
    return false;
  }
  const emailChunks = (email?.split("@")[0] ?? "")
    .split(/[-_.+]/i)
    .filter(Boolean);
  let matchFound = false;
  emailChunks.forEach((chunk: string) => {
    const isMatch = new RegExp(escapeRegex(chunk), "i").test(password);
    if (isMatch) {
      matchFound = true;
    }
  });

  return matchFound;
};

export const validateName = (
  forename: string | undefined,
  surname: string | undefined,
  password: string,
): boolean => {
  const nameChunks: string[] = [
    ...(forename ? forename.split(/[-_.+ ]/i).filter(Boolean) : []),
    ...(surname ? surname.split(/[-_.+ ]/i).filter(Boolean) : []),
  ];
  if (nameChunks.length === 0) {
    return false;
  }
  let matchFound = false;
  nameChunks.forEach((chunk: string) => {
    const isMatch = new RegExp(escapeRegex(chunk), "i").test(password);
    if (isMatch) {
      matchFound = true;
    }
  });

  return matchFound;
};

export const validateJobTitle = (
  jobTitle: string | undefined,
  password: string,
): boolean => {
  const jobTitleChunks: string[] = [
    ...(jobTitle ? jobTitle.split(/[-_.+ ]/i).filter(Boolean) : []),
  ];
  if (jobTitleChunks.length === 0) {
    return false;
  }
  let matchFound = false;
  jobTitleChunks.forEach((chunk: string) => {
    const isMatch = new RegExp(escapeRegex(chunk), "i").test(password);
    if (isMatch) {
      matchFound = true;
    }
  });

  return matchFound;
};
